import React, { useRef } from 'react'
import { SkillBiteEditSlice } from '../../../../../reducers'
import { useSelector } from 'react-redux'
import { IconButton, Tooltip } from '@mui/material'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { BannerStatic } from '../../../../../components'
import { EditRounded } from '@mui/icons-material'
import SectionFormDialog from '../section-form-dialog'

const RenameSectionDialog = ({ section, sessionId, className }) => {
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)

  const modalRef = useRef()

  const [renameSection] = useEvent([
    SkillBiteEditSlice.eventBus.renameSection({
      onSuccess: () => {
        BannerStatic.show({
          label: 'Section renamed successfully'
        })
        modalRef.current.close()
      },
      onError: (error) => {
        console.log(error)
        BannerStatic.show({
          label: 'Error trying to rename section',
          isError: true
        })
        modalRef.current.close()
      }
    })
  ])

  const handleClickOpen = (evt) => {
    evt.preventDefault()
    evt.stopPropagation()
    modalRef.current.open({
      name: section.name
    })
  }

  const handleOnSubmit = (data) => {
    renameSection.trigger({
      skillBiteId: skillBite.id,
      sessionId,
      sectionId: section.id,
      name: data.name
    })
  }

  return (
    <>
      <Tooltip placement='top' title='Rename Section'>
        <IconButton
          data-test='rename-section-btn'
          onClick={handleClickOpen}
          aria-label='Rename Section'
          size='small'
          sx={{ height: '30px', width: '30px' }}
          className={className}
        >
          <EditRounded
            fontSize='small'
          />
        </IconButton>
      </Tooltip>

      <SectionFormDialog
        title='Rename Section'
        submitText='Save'
        isLoading={renameSection.isWorking}
        ref={modalRef}
        onSubmit={handleOnSubmit}
        section={section}
      />
    </>
  )
}

export default RenameSectionDialog
